import { ROLE_LABEL } from '@app/shared/core';
import { Logo } from '../brand/Logo';
import { useApp } from '../state';

/** Должность и, у администратора, пометка «администратор». */
export function roleLine(e: { position: string | null; role: 'admin' | 'employee' }): string {
  if (e.role === 'admin') return e.position ? `${e.position} · администратор` : ROLE_LABEL.admin;
  return e.position ?? ROLE_LABEL.employee;
}

/** Шапка вкладок: логотип и кто вошёл. */
export function TopBar() {
  const { me } = useApp();
  const e = me.employee;
  return (
    <header className="topbar">
      <Logo height={14} />
      {e && (
        <div className="who">
          <div className="ellipsis" style={{ maxWidth: 180 }}>{e.fullName}</div>
          <div className="ellipsis" style={{ maxWidth: 180 }}>{e.position ?? ROLE_LABEL[e.role]}</div>
        </div>
      )}
    </header>
  );
}
